<template>
    <b-img-lazy
        v-bind="image_props"
        :src="model.images[0]"
        v-if="model.images && model.images.length"
        >
    </b-img-lazy>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    components: {
    },
    props: {
        model: {
            type: Object,
            required: true,
            default() {
                return {}
            },
        },
    },
    data() {
        return {
            image_props: {
                center: true,
//                fluidGrow: true,
                blank: true,
                blankColor: '#bbb',
                width: 100,
                height: 100,
                style: 'aspect-ratio: unset; object-fit: contain; background: rgba(0,0,0,0.3);',
//                class: 'my-5'
            },
            src: 'https://www.revu.com.ph/wp-content/gallery/oppo-reno-4-sample-selfie-pictures/OPPO-Reno-4-sample-selfie-picture-Revu-Philippines-a.jpg',
        }
    },
    computed: {
        ...mapGetters([
            'trans',
        ])
    },
    async mounted() {},
    methods: {
        getValueByKey(value, key) {
            let arr
            try {
                arr = JSON.parse(value)
            } catch (e) {}
            if (typeof arr !== 'object') {
                return value
            }
            return Array.isArray(arr[key]) ? arr[key].join('\n') : arr[key] || ''
        },
    },
}
</script>

<style lang="scss" scoped></style>

